import { render, staticRenderFns } from "./addDoctor.vue?vue&type=template&id=2cd72638&scoped=true&"
import script from "./addDoctor.vue?vue&type=script&lang=js&"
export * from "./addDoctor.vue?vue&type=script&lang=js&"
import style0 from "./addDoctor.vue?vue&type=style&index=0&id=2cd72638&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd72638",
  null
  
)

export default component.exports